<p class="migration-notification-title">{{'migration-notification.popup-title' | translate}}</p>
<p
	class="migration-notification-body"
	[innerHTML]="'migration-notification.popup-body' | translate: { dateWithTime: dateWithTime}"
></p>

<button class="migration-notification-button" type="button" mat-flat-button (click)="closeDialog()">
	{{ 'general.close' | translate }}
</button>
